export default {
  small: {
    width: "fit-content",
    height: "25px",
    display: "flex",
    "justify-content": "center",
    "align-items": "center",
  },
};
